import { render, staticRenderFns } from "./ProvinceCard.vue?vue&type=template&id=4abfac26&scoped=true"
import script from "./ProvinceCard.vue?vue&type=script&lang=js"
export * from "./ProvinceCard.vue?vue&type=script&lang=js"
import style0 from "./ProvinceCard.vue?vue&type=style&index=0&id=4abfac26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abfac26",
  null
  
)

export default component.exports